import { render } from "./CustomCategoriesComponent.vue?vue&type=template&id=221bc803"
import script from "./CustomCategoriesComponent.vue?vue&type=script&lang=js"
export * from "./CustomCategoriesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__